module.exports = __webpack_public_path__ + "static/media/archive_sample.2219ade.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/video-archive/archive_sample.mp4
// module id = CU/D
// module chunks = 0